import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Search } from "lucide-react";

export default function Customers() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [detail, setDetail] = useState(null);

  const load = async () => {
    const r = await api.get("/customers", { params: search ? { search } : {} });
    setItems(r.data);
  };
  useEffect(() => { load(); }, [search]);

  const open = async (c) => {
    const r = await api.get(`/customers/${c.id}`);
    setDetail(r.data);
  };

  return (
    <Layout title="Customers" subtitle="Loyalty members"
      action={
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8C8C8C]" />
          <input className="fin" style={{paddingLeft:36, width:280}} placeholder="Search name or number" value={search} onChange={(e) => setSearch(e.target.value)} data-testid="customer-search" />
        </div>
      }>
      <div className="card-sharp">
        <table className="fin">
          <thead><tr><th>Name</th><th>WhatsApp</th><th>Tier</th><th>Points</th><th>Last seen</th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="cursor-pointer" onClick={() => open(c)} data-testid={`customer-row-${c.id}`}>
                <td className="font-medium">{c.name}</td>
                <td className="font-mono text-[12px]">{c.wa_number}</td>
                <td><span className="badge badge-gold">{c.tier || "Silver"}</span></td>
                <td>{c.points || 0}</td>
                <td className="text-[#8C8C8C] text-[12px]">{c.last_seen ? new Date(c.last_seen).toLocaleString() : "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="5" className="text-center py-8 text-[#8C8C8C]">No customers yet. Use the WhatsApp simulator to add some.</td></tr>}
          </tbody>
        </table>
      </div>

      {detail && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-6 z-50" onClick={() => setDetail(null)}>
          <div className="bg-white max-w-3xl w-full p-7 max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between mb-6">
              <div>
                <div className="label-tiny">Customer</div>
                <div className="text-2xl font-light" style={{fontFamily:"Outfit"}}>{detail.customer.name}</div>
                <div className="font-mono text-[12px] text-[#8C8C8C]">{detail.customer.wa_number}</div>
                {(detail.customer.registered_brand_name || detail.customer.registered_location_name) && (
                  <div className="mt-2 flex items-center gap-2 text-[11px]">
                    <span className="label-tiny">Registered via</span>
                    {detail.customer.registered_brand_name && <span className="badge badge-gold">{detail.customer.registered_brand_name}</span>}
                    {detail.customer.registered_location_name && <span className="badge badge-pending">{detail.customer.registered_location_name}</span>}
                  </div>
                )}
              </div>
              <div className="text-right">
                <div className="label-tiny">Points</div>
                <div className="text-3xl font-light" style={{fontFamily:"Outfit"}}>{detail.customer.points || 0}</div>
                <span className="badge badge-gold mt-1 inline-block">{detail.customer.tier || "Silver"}</span>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-6">
              <Section title="Bills" count={detail.bills.length} />
              <Section title="Claims" count={detail.claims.length} />
              <Section title="Points history" count={detail.points_log.length} />
            </div>

            <div className="space-y-4">
              <div>
                <div className="label-tiny mb-2">Recent claims</div>
                {detail.claims.slice(0,5).map(c => (
                  <div key={c.id} className="text-sm border-b border-[#E6E4E0] py-2 flex justify-between">
                    <span>{c.brand_name} — {c.offer_title}</span>
                    <span className="text-[12px] text-[#8C8C8C]">until {c.valid_until?.slice(0,10)}</span>
                  </div>
                ))}
                {detail.claims.length === 0 && <div className="text-[#8C8C8C] text-sm">No claims.</div>}
              </div>

              <div>
                <div className="label-tiny mb-2">Bills</div>
                {detail.bills.slice(0,5).map(b => (
                  <div key={b.id} className="text-sm border-b border-[#E6E4E0] py-2 flex justify-between">
                    <span>{new Date(b.created_at).toLocaleString()}</span>
                    <span className={`badge badge-${b.status}`}>{b.status}</span>
                  </div>
                ))}
                {detail.bills.length === 0 && <div className="text-[#8C8C8C] text-sm">No bills.</div>}
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button className="btn-outline" onClick={() => setDetail(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
const Section = ({title, count}) => (
  <div className="card-sharp p-4 text-center">
    <div className="label-tiny mb-1">{title}</div>
    <div className="text-2xl font-light" style={{fontFamily:"Outfit"}}>{count}</div>
  </div>
);
